export const ComponentDefinitionIds = {
  CHECKBOX_GROUP: "application/vnd.pivotalgroup.component.checkbox-group+json",
  NUMBER_INPUT: "application/vnd.pivotalgroup.component.number-input+json",
  RADIO_GROUP: "application/vnd.pivotalgroup.component.radio-group+json",
  SELECT_INPUT: "application/vnd.pivotalgroup.component.select-input+json",
  TEXT_INPUT: "application/vnd.pivotalgroup.component.text-input+json",
  ACCORDION_ITEM: "application/vnd.pivotalgroup.component.accordion-item+json",
  ACCORDION: "application/vnd.pivotalgroup.component.accordion+json",
  CARD_CONTENT: "application/vnd.pivotalgroup.component.card-content+json",
  CARD_FOOTER: "application/vnd.pivotalgroup.component.card-footer+json",
  CARD_HEADER_DESCRIPTION: "application/vnd.pivotalgroup.component.card-header-description+json",
  CARD_HEADER: "application/vnd.pivotalgroup.component.card-header+json",
  CARD_HEADER_TITLE: "application/vnd.pivotalgroup.component.card-header-title+json",
  CARD: "application/vnd.pivotalgroup.component.card+json",
  CONDITIONAL_VISIBILITY: "application/vnd.pivotalgroup.component.conditional-visibility+json",
  CONTAINER: "application/vnd.pivotalgroup.component.container+json",
  FORM_CONTAINER: "application/vnd.pivotalgroup.component.form-container+json",
  FORM_SUBMIT: "application/vnd.pivotalgroup.component.form-submit+json",
  ASSESSMENT_NAVIGATION: "application/vnd.pivotalgroup.component.assessment-navigation+json",
  TAB_ITEM: "application/vnd.pivotalgroup.component.tab-item+json",
  TABS: "application/vnd.pivotalgroup.component.tabs+json",
  HERO: "application/vnd.pivotalgroup.component.hero+json",
  IMAGE: "application/vnd.pivotalgroup.component.image+json",
  MARKDOWN: "application/vnd.pivotalgroup.component.markdown+json",
  PDF_REPORT_DOWNLOAD: "application/vnd.pivotalgroup.component.pdf-report-download+json",
  TIMER: "application/vnd.pivotalgroup.component.timer+json",
  RESOURCE_INCLUDE: "application/vnd.pivotalgroup.component.resource-include+json",
  UPLOAD_DOCUMENTS: "application/vnd.pivotalgroup.component.upload-documents+json",
  VOICE_NOTE: "application/vnd.pivotalgroup.component.voice-note+json",
  VIDEO: "application/vnd.pivotalgroup.component.video+json",
  YOUTUBE: "application/vnd.pivotalgroup.component.youtube+json",
  NAVIGATION_HEADER: "application/vnd.pivotalgroup.component.navigation-header+json",
  NAVIGATION_PAGE: "application/vnd.pivotalgroup.component.navigation-page+json",
  NAVIGATION_PAGE_LIST: "application/vnd.pivotalgroup.component.navigation-page-list+json",
  NAVIGATION_STEPPER_01: "application/vnd.pivotalgroup.component.navigation-stepper-01+json",
  NAVIGATION_STEPPER_02: "application/vnd.pivotalgroup.component.navigation-stepper-02+json",
  REDIRECT: "application/vnd.pivotalgroup.component.navigation-redirect+json",
  USER_STATE_REDIRECT: "application/vnd.pivotalgroup.component.user-state-redirect+json",
  COMPETENCIES_REPORT: "application/vnd.pivotalgroup.component.report.competencies+json",
  COMPETENCY_PROFILE_REPORT: "application/vnd.pivotalgroup.component.report.competency-profile+json",
  DEVELOPMENT_AREAS_REPORT: "application/vnd.pivotalgroup.component.report.development-areas+json",
  KEY_STRENGTHS_REPORT: "application/vnd.pivotalgroup.component.report.key-strengths+json",
  COMPETENCY_DESCRIPTIONS_REPORT: "application/vnd.pivotalgroup.component.report.competency-descriptions+json",
  COMPETENCY_SUMMARY_REPORT: "application/vnd.pivotalgroup.component.report.competency-summary+json",
  USER_SELECT_REPORT: "application/vnd.pivotalgroup.component.report.user-select+json",
  RANKED_REPORT: "application/vnd.pivotalgroup.component.report.ranked+json",
  RANKED_REPORT_RAW: "application/vnd.pivotalgroup.component.report.ranked.raw+json",
  RANKED_EXPLORER_RAW: "application/vnd.pivotalgroup.component.report.ranked-explorer.raw+json",
  REPORT_BAR_CHART: "application/vnd.pivotalgroup.component.report.bar-chart+json",
  REPORT_DESCRIPTIONS: "application/vnd.pivotalgroup.component.report.descriptions+json",
  REPORT_PROVIDER: "application/vnd.pivotalgroup.component.report.provider+json",
  REPORT_PROVIDER_RAW: "application/vnd.pivotalgroup.component.report.provider.raw+json",
  REPORT_PROVIDER_MOCK: "application/vnd.pivotalgroup.component.report.provider.mock+json",
  REPORT_PROVIDER_DEBUGGER: "application/vnd.pivotalgroup.component.report.provider-debugger+json",
  COVER_PAGE: "application/vnd.pivotalgroup.component.report.cover-page+json",
  TABLE_OF_CONTENTS: "application/vnd.pivotalgroup.component.report.table-of-contents+json",
  PAGE_HEADER: "application/vnd.pivotalgroup.component.report.page-header+json",
  PAGE_FOOTER: "application/vnd.pivotalgroup.component.report.page-footer+json",
  PAGE_BREAK: "application/vnd.pivotalgroup.component.report.page-break+json",
  SUBMIT_ASSESSMENT: "application/vnd.pivotalgroup.component.submit-assessment+json",
  ABSORB_GET_COURSES_NODE: "application/vnd.pivotalgroup.automation.node.absorb-get-courses+json",
  ABSORB_GET_USERS_NODE: "application/vnd.pivotalgroup.automation.node.absorb-get-users+json",
  ABSORB_ENROLL_USERS_NODE: "application/vnd.pivotalgroup.automation.node.absorb-enroll-users+json",

  UNOVIS_SINGLE_CONTAINER: "application/vnd.pivotalgroup.component.unovis.single+json",
  UNOVIS_SINGLE_DONUT: "application/vnd.pivotalgroup.component.unovis.single.donut+json",
  
  UNOVIS_XY_CONTAINER: "application/vnd.pivotalgroup.component.unovis.xy+json",
  UNOVIS_XY_STACKED_BAR: "application/vnd.pivotalgroup.component.unovis.xy.stacked-bar+json",
  UNOVIS_XY_GROUPED_BAR: "application/vnd.pivotalgroup.component.unovis.xy.grouped-bar+json",
  UNOVIS_XY_LINE: "application/vnd.pivotalgroup.component.unovis.xy.line+json",
  UNOVIS_XY_AREA: "application/vnd.pivotalgroup.component.unovis.xy.area+json",
  UNOVIS_XY_SCATTER: "application/vnd.pivotalgroup.component.unovis.xy.scatter+json",
  UNOVIS_XY_X_AXIS: "application/vnd.pivotalgroup.component.unovis.xy.x-axis+json",
  UNOVIS_XY_Y_AXIS: "application/vnd.pivotalgroup.component.unovis.xy.y-axis+json",

  UNOVIS_LEGEND_BULLET: "application/vnd.pivotalgroup.component.unovis.legend.bullet+json",
} as const;
